import React, { useMemo, useState } from "react";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";
import { UserNotificationsDropdown } from "../extras/dropdowns/UserNotificationsDropdown";
import { QuickActionsDropdown } from "../extras/dropdowns/QuickActionsDropdown";
import { MyCartDropdown } from "../extras/dropdowns/MyCartDropdown";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import Select from "react-select";
import { red } from "@material-ui/core/colors";
import { selectUser } from "../../../../app/modules/Auth/_redux/authRedux";
import { useSelector, useDispatch } from "react-redux";
import {
  assginOffice,
  selectLoading,
} from "../../../../app/pages/user/userSlice";
import { showErrorDialog, showSuccessDialog } from "../../../../app/utility";
import { useHistory } from "react-router-dom";
import { LayoutSplashScreen } from "../../_core/MetronicSplashScreen";

export function Topbar() {
  const uiService = useHtmlClassService();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);

  const [office, setOffice] = useState(user.active_office);

  const defaultOffice = user.active_office === null ? "" : user.active_office;

  console.log(defaultOffice);

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: 200,
      background: "#fffff",

      color: "white",
    }),
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleTypeChange = async (e) => {
    if (e === null) {
      e = undefined;
      setOffice("");
    } else {
      const params = {
        active_office: e.value,
      };

      try {
        const response = await dispatch(assginOffice(params));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
      await history.push("/dashboard");
          await window.location.reload();
        } else if (
          response.payload.error === "10008" ||
          response.payload.error === "10009"
        ) {
          const action = await showErrorDialog(response.payload.message);
      await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error, "masukcatch");
      }
    }
  };

  const paramOptions = user.userOffices.map((e) => {
    return {
      value: e.office_code,
      label: e.office_code,
    };
  });

  const handleSelect = async (e) => {
    console.log(e);
    const params = {
      active_office: e,
    };

    console.log(params);

    try {
      const response = await dispatch(assginOffice(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
       await history.push("/dashboard");
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error, "masukcatch");
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <div className="topbar">
      {/* {layoutProps.viewSearchDisplay && <SearchDropdown />} */}

      <div className="topbar-item-select ">
        <Dropdown onSelect={handleSelect}>
          <Dropdown.Toggle className="my-btn-primary-dark" id="dropdown-basic">
            {defaultOffice}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {paramOptions.map((item) => {
              return (
                <Dropdown.Item eventKey={item.value}>
                  {item.label}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* {layoutProps.viewNotificationsDisplay && <UserNotificationsDropdown />} */}

      {/* {layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown />}

      {layoutProps.viewCartDisplay && <MyCartDropdown />} */}

      {/* {layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Quick panel"
            data-placement="right"
          >
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_panel_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Layout/Layout-4-blocks.svg"
                  )}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
      )} */}

      {/* {layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />} */}

      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
